// Find icons at: https://materialdesignicons.com/
import {
    mdiShapePolygonPlus,
    mdiShapeRectanglePlus,
    mdiShapeCirclePlus,
    mdiPencil,
    mdiSelectOff,
    mdiDelete,
    mdiClose,
    mdiRedo,
    mdiChevronLeft,
    mdiChevronRight,
    mdiUndo,
    mdiContentSave,
    mdiImagePlus,
    mdiAlert,
    mdiEye,
    mdiCheck,
    mdiInformation,
    mdiMagnify,
    mdiPlusBoxMultiple,
    mdiMapMarker,
    mdiChevronDown,
    mdiChevronUp,
    mdiClockTimeFourOutline,
    mdiBuffer,
    mdiAccountGroup,
    mdiClockTimeFour,
    mdiMenuDown,
    mdiCog,
    mdiAccountCircle,
    mdiArrowLeftCircle,
    mdiDotsVertical,
    mdiAccountMultiple,
    mdiFileDocument,
    mdiVideo,
    mdiMap,
    mdiFilterVariant,
    mdiStorefrontOutline,
    mdiAccount,
    mdiHelpCircle,
    mdiLogout,
    mdiEyeOff,
    mdiMicrophone,
    mdiAccountCheck,
    mdiLinkedin,
    mdiFacebook,
    mdiTwitter,
    mdiInstagram,
    mdiCrosshairsGps,
    mdiDrag,
    mdiPlus,
    mdiEmail,
    mdiArrowExpandAll,
    mdiCursorDefaultOutline,
    mdiMagnifyPlusOutline,
    mdiMagnifyMinus,
    mdiCalendarRangeOutline,
    mdiArrowUpBold,
    mdiArrowDownBold,
    mdiEmailSendOutline,
    mdiCheckCircle,
    mdiNoteMultiple,
    mdiRocketLaunchOutline,
    mdiDomain,
    mdiArrowRight,
    mdiPresentationPlay,
    mdiVideoAccount,
    mdiTheater,
    mdiHumanGreetingProximity,
    mdiFileImageOutline,
    mdiBriefcase,
    mdiWeb,
    mdiShieldAccountVariant,
    mdiWalletMembership,
    mdiAutorenew,
    mdiCalendarToday,
    mdiTranslate,
    mdiMinus,
    mdiCloseCircle,
    mdiShieldCheck,
    mdiCalendarClockOutline,
    mdiLink,
    mdiHandshake,
    mdiYoutubeTv,
    mdiTimetable,
    mdiGoogleTranslate,
} from '@mdi/js'
import { performerIcon } from './customPaths'

export const iconPaths = {
    polygon: mdiShapePolygonPlus,
    rectangle: mdiShapeRectanglePlus,
    circle: mdiShapeCirclePlus,
    select: mdiPencil,
    edit: mdiPencil,
    delete: mdiSelectOff,
    trash: mdiDelete,
    previous: mdiChevronLeft,
    next: mdiChevronRight,
    alert: mdiAlert,
    close: mdiClose,
    view: mdiEye,
    check: mdiCheck,
    info: mdiInformation,
    clear: mdiDelete,
    redo: mdiRedo,
    undo: mdiUndo,
    addImage: mdiImagePlus,
    save: mdiContentSave,
    search: mdiMagnify,
    plusBox: mdiPlusBoxMultiple,
    mapMarker: mdiMapMarker,
    chevronDown: mdiChevronDown,
    chevronUp: mdiChevronUp,
    clock: mdiClockTimeFour,
    clockOutline: mdiClockTimeFourOutline,
    buffer: mdiBuffer,
    group: mdiAccountGroup,
    menuDown: mdiMenuDown,
    cog: mdiCog,
    accountCircle: mdiAccountCircle,
    arrowLeftCircle: mdiArrowLeftCircle,
    drag: mdiDotsVertical,
    accountMultiple: mdiAccountMultiple,
    fileDocument: mdiFileDocument,
    video: mdiVideo,
    map: mdiMap,
    filter: mdiFilterVariant,
    store: mdiStorefrontOutline,
    account: mdiAccount,
    help: mdiHelpCircle,
    logout: mdiLogout,
    viewOff: mdiEyeOff,
    microphone: mdiMicrophone,
    accountCheck: mdiAccountCheck,
    linkedIn: mdiLinkedin,
    facebook: mdiFacebook,
    twitter: mdiTwitter,
    instagram: mdiInstagram,
    navigation: mdiCrosshairsGps,
    dragVertical: mdiDrag,
    plus: mdiPlus,
    email: mdiEmail,
    expand: mdiArrowExpandAll,
    cursor: mdiCursorDefaultOutline,
    zoomIn: mdiMagnifyPlusOutline,
    zoomOut: mdiMagnifyMinus,
    calendar: mdiCalendarRangeOutline,
    arrowUp: mdiArrowUpBold,
    arrowDown: mdiArrowDownBold,
    emailSend: mdiEmailSendOutline,
    checkCircle: mdiCheckCircle,
    clipboard: mdiNoteMultiple,
    rocket: mdiRocketLaunchOutline,
    organisation: mdiDomain,
    arrowRight: mdiArrowRight,
    presentation: mdiPresentationPlay,
    meeting: mdiVideoAccount,
    cinema: mdiTheater,
    networking: mdiHumanGreetingProximity,
    poster: mdiFileImageOutline,
    job: mdiBriefcase,
    web: mdiWeb,
    organizationAdmin: mdiShieldAccountVariant,
    membership: mdiWalletMembership,
    renew: mdiAutorenew,
    calendarToday: mdiCalendarToday,
    translate: mdiTranslate,
    minus: mdiMinus,
    closeCircle: mdiCloseCircle,
    shieldCheck: mdiShieldCheck,
    dotsVertical: mdiDotsVertical,
    calendarClock: mdiCalendarClockOutline,
    link: mdiLink,
    virtual: mdiYoutubeTv,
    handShake: mdiHandshake,
    hybrid: mdiTheater,
    timetable: mdiTimetable,
    performer: performerIcon,
    googleTranslate: mdiGoogleTranslate,
}

export type IconOption = keyof typeof iconPaths
